module.exports = __webpack_public_path__ + "static/img/bs_logo_footer.f861d15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bs_logo_footer.png
// module id = ufye
// module chunks = 0